(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('receipt-file', {
                parent: 'entity',
                url: '/receipt-file',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.receiptFile.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/receipt-file/receipt-files.html',
                        controller: 'ReceiptFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('receiptFile');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('receipt-file-detail', {
                parent: 'entity',
                url: '/receipt-file/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.receiptFile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/receipt-file/receipt-file-detail.html',
                        controller: 'ReceiptFileDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('receiptFile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ReceiptFile', function ($stateParams, ReceiptFile) {
                        return ReceiptFile.get({ id: $stateParams.id }).$promise;
                    }]
                }
            })
            .state('receipt-file-detail/edit', {
                parent: 'receipt-file-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-dialog.html',
                        controller: 'ReceiptFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReceiptFile', function (ReceiptFile) {
                                return ReceiptFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('receipt-file/new', {
                parent: 'receipt-file',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-dialog.html',
                        controller: 'ReceiptFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileName: null,
                                    fileContentType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('receipt-file', null, { reload: true });
                    }, function () {
                        $state.go('receipt-file');
                    });
                }]
            })
            .state('receipt-file/edit', {
                parent: 'receipt-file',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-dialog.html',
                        controller: 'ReceiptFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReceiptFile', function (ReceiptFile) {
                                return ReceiptFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('receipt-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('receipt-file/delete', {
                parent: 'receipt-file',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-delete-dialog.html',
                        controller: 'ReceiptFileDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ReceiptFile', function (ReceiptFile) {
                                return ReceiptFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('receipt-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
